export default "__VITE_ASSET__CSFnhENc__"